var React = require('react');

function RulerPencil (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-3-1h48v48H-3z","key":0}),React.createElement("g",{"stroke":"#FFF","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1},React.createElement("path",{"d":"M28 34h14M28 9h14M42 34l-7 9-7-9V1h14zM1 11h8M1 19h6M1 27h8M1 35h6M1 1h16v44H1z"}))]));
}

RulerPencil.defaultProps = {"width":"43","height":"46","viewBox":"0 0 43 46"};

module.exports = RulerPencil;

RulerPencil.default = RulerPencil;
